/*eslint-disable */
define(
    [
        "jquery", "modernizr"
    ],
    function($) {
        if (!Modernizr.localstorage) {
            return;
        }

        storeData();
        populateFieldsWithStoredData();

        function storeData(callback) {
            $("input.persistent-field, textarea.persistent-field").on({
                "blur": function() { saveItem(this); },
                "change": function(){ saveItem(this); },
                "input": function(){ saveItem(this); }
            });

            $("select.persistent-field").on("change", function() {
                saveItem(this);
            });

            function saveItem(element) {
                var $element = $(element);
                var name = $element.data("persist-name") || $element.attr("name");
                var value = $element.val();

                localStorage.setItem(name, value);
            }
        }

        function populateFieldsWithStoredData(callback){

            $(".persistent-field").each(function() {
                var $field = $(this);
                var name = $field.data("persist-name") || $field.attr("name");
                var value = localStorage[name];

                if (value) {
                    if(!$field.val() || $field.val().length <= 0) {
                        $field.val(value);
                    }

                    if (this.tagName === "SELECT") {
                        $field.change();
                    }
                }
            });
        }
    }
)
